/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivityTrackerPreferenceResource
 */
export interface ActivityTrackerPreferenceResource {
    /**
     * 
     * @type {boolean}
     * @memberof ActivityTrackerPreferenceResource
     */
    granularActivityTracker: boolean;
}

/**
 * Check if a given object implements the ActivityTrackerPreferenceResource interface.
 */
export function instanceOfActivityTrackerPreferenceResource(value: object): value is ActivityTrackerPreferenceResource {
    if (!('granularActivityTracker' in value) || value['granularActivityTracker'] === undefined) return false;
    return true;
}

export function ActivityTrackerPreferenceResourceFromJSON(json: any): ActivityTrackerPreferenceResource {
    return ActivityTrackerPreferenceResourceFromJSONTyped(json, false);
}

export function ActivityTrackerPreferenceResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityTrackerPreferenceResource {
    if (json == null) {
        return json;
    }
    return {
        
        'granularActivityTracker': json['granularActivityTracker'],
    };
}

export function ActivityTrackerPreferenceResourceToJSON(value?: ActivityTrackerPreferenceResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'granularActivityTracker': value['granularActivityTracker'],
    };
}

